import { Navigate, Outlet } from "react-router-dom";
import { useAuth } from "../contexts/AuthContext";

/**
 * Guard for the whole `/admin` route block. Defense-in-depth on top of the
 * backend `requireSuperAdmin` gate: only users with role "owner" (the platform
 * superadmin, never a restaurant's admin/staff) may render any admin page.
 * A non-superadmin that navigates to /admin/* by hand is redirected to the
 * dashboard instead of seeing the page shell.
 */
export default function AdminRoute() {
  const { user, isAuthenticated, isLoading } = useAuth();

  if (isLoading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-gray-50">
        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-primary-600"></div>
      </div>
    );
  }

  if (!isAuthenticated) {
    return <Navigate to="/login" replace />;
  }

  if (user?.role !== "owner") {
    return <Navigate to="/" replace />;
  }

  return <Outlet />;
}
